import React from "react";

function NetworkStatus({ provider }) {  
  return (
    <div className="network-status">
      {provider ? (
        <span className="text-green-500">Connected</span>
      ) : (
        <span className="text-red-500">Disconnected</span>
      )}
    </div>
  );
}

export default NetworkStatus;
